module.exports = __webpack_public_path__ + "media/promo/courses/images/s1-8163a661d90110f896f51c1f49ce97f1.jpg";